import { Controller } from '@hotwired/stimulus';
import { formatDateJa } from '../formatDateJa';

export default class extends Controller {
  static targets = ['dateInput', 'nameInput', 'setNameCheckbox', 'scheduleRows'];

  apply() {
    const date = this.dateInputTarget.value;
    if (!date) {
      return;
    }

    const dateInputs = this.scheduleRowsTarget.querySelectorAll('.nested-fields:not([style*="display: none"]) input[type="date"]');
    dateInputs.forEach((input) => {
      input.value = date;
    });

    if (this.setNameCheckboxTarget.checked) {
      const [year, month, day] = date.split('-').map(Number);
      this.nameInputTarget.value = formatDateJa(new Date(year, month - 1, day));
    }
  }
}
